import { $ } from '@/libs/jquery/index'
import { leadsRemoteFormSelector } from '@/views/application/leads/shared/remote_form/index'

export class Sidebar {
  public base: JQuery | null = null

  private readonly selectors: ISelectors = {
    base: '[data-selector="sidebar"]',
    sidebarItem: '[data-selector="sidebarItem"]',
  }

  private readonly classes: ISelectors = {
    elementStopMenu: '.js-position-stop',
    linkActive: 'is-active',
    menuFixed: 'is-fixed',
    menuStopFixed: 'is-fixedBottom',
  }

  constructor() {
    this.base = $(this.selectors.base)

    if (this.base.length) {
      this.init()
    }
  }

  public init(): void {
    if ($(leadsRemoteFormSelector).length > 0) {
      $(document)
        .on('form:lead:rendered', () => {
          this.setActiveItems()
          this.scrollToTop()
        })
    } else {
      this.setActiveItems()
      this.scrollToTop()
    }
    this.initSidebarPosition()
  }

  // скролл по нажатию на все элементы, которые удовлетворяют селектору
  private scrollToTop(): void {
    const items = $('body').find(`[href*='#']${this.selectors.sidebarItem}:not([href='#'])`)
    items.on('click', (e) => {
      e.preventDefault()
      const elem = e.currentTarget as HTMLAnchorElement
      if (location.pathname.replace(/^\//, '') === elem.pathname.replace(/^\//, '')
        && location.hostname === elem.hostname) {
        let target = $(elem.hash)
        const hashSubstr = elem.hash.substr(1)
        target = target.length ? target : $(`[name='${ hashSubstr}']`)
        if (target.length) {
          $('html, body')
            .stop()
            .animate({ scrollTop: target.offset().top }, 700, 'linear')
        }
      }
    })
  }

  // активные только те ссылки, что находятся внутри меню
  private setActiveItems(): void {
    const items = this.base.find(this.selectors.sidebarItem)
    const checkingElementsYPositions = []

    items.each((index, element) => {
      const targetBlock = $(element).attr('href')
      if (targetBlock.indexOf('#') !== -1) {
        const $targetBlock = $(targetBlock)
        const startPosition = $targetBlock.offset().top - 100
        const stopPosition = startPosition + $targetBlock.height()
        const $targetBlockPosition = [startPosition, stopPosition]
        checkingElementsYPositions.push($targetBlockPosition)
      }
    })

    this.checkLinksPosition(items, checkingElementsYPositions)

    $(window).on('scroll', () => this.checkLinksPosition(items, checkingElementsYPositions))
  }

  private checkLinksPosition(items: JQuery, positions): void {
    const windowScrollTop = $(window).scrollTop()
    positions.forEach((element, index) => {
      if (windowScrollTop > element[0] && windowScrollTop < element[1]) {
        items.eq(index).addClass(this.classes.linkActive)
      } else {
        items.eq(index).removeClass(this.classes.linkActive)
      }
    })
  }

  private initSidebarPosition(): void {
    const sidebarMenuPosition = this.base.offset().top

    this.checkMenuPosition(sidebarMenuPosition)
    $(window).on('scroll', () => this.checkMenuPosition(sidebarMenuPosition))
  }

  private checkMenuPosition(sidebarMenuPosition: number): void {
    const sidebarMenuHeight = this.base.height()

    let bottomElement = $(this.classes.elementStopMenu)[0]
    if ($(bottomElement).hasClass('hidden')) {
      bottomElement = $(this.classes.elementStopMenu)[1]
    }

    const endPosition = $(bottomElement).offset().top - sidebarMenuHeight - 100

    const documentScrollTop = $(document).scrollTop() + 60

    if (sidebarMenuPosition < documentScrollTop) {
      this.base.addClass(this.classes.menuFixed)
    } else {
      this.base.removeClass(this.classes.menuFixed)
    }

    if (documentScrollTop >= endPosition) {
      this.base
        .addClass(this.classes.menuStopFixed)
        .css('top', 'auto')
        .css('bottom', '0')
    } else {
      this.base
        .removeClass(this.classes.menuStopFixed)
        .css('top', '60px')
        .css('bottom', 'auto')
    }
  }
}
